import { useEffect } from 'react';
import { accountService } from '../../services';
import { useAppDispatch } from '../../effects/useAppDispatch';

export function Logout() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        accountService.apiLogout().catch(() => {});
        accountService.logout();
    }, [dispatch]);

    return null;
}
